import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchForm(ctx, ID) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/forms/${ID}`)
          .then(response => {
            resolve(response.data.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}